import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  addFavorite,
  getBusinessDetail,
  getBusinessEvent,
  removeFavorite,
} from "../../../Redux/Action/BusinessAction/businesAction";
import { useNavigate } from "react-router-dom";
import { isArray, isEmpty } from "lodash";
import { formatPhone } from "../../../Utils/localStroge";
import {
  getAnnouncements,
  getOffer,
  getPropertyList,
  getSales,
} from "../../../API/ApiService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Reviews from "./reviews/Reviews";
import Events from "./events/Events";
import Announcements from "./announcements/Announcements";
import Sales from "./sales/Sales";
import SalesPopup from "./sales/SalesPopup";
import Offers from "./offers/Offers";
// import OfferPopup from "./offers/OfferPopup";
// import LoginPopup from "./login-popup/LoginPopup";
import Slider from "./slider/Slider";
import BusinessOpenHours from "./business-open-hours/BusinessOpenHours";
import { formatHttpsLink } from "../../../Utils/helperFunction";
import { AiFillTikTok } from "react-icons/ai";
import Property from "./property/Property";
const BusinessDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isbusiness, setBusiness] = useState({});
  const [event, setEvent] = useState({});
  const [propertyList, setProperty] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [sales, setSales] = useState([]);
  const [offers, setOffers] = useState([]);
  const [isBusinessHours, setBusinessHours] = useState({});
  const [visible, setVisible] = useState(3);
  const [isOpenSaleModal, setIsOpenSaleModal] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);
  const [loading, setLoading] = useState(false);
  const [businessLoading, setBusinessLoading] = useState(false);

  const [isOpenEventModal, setIsOpenEventModal] = useState({
    data: {},
    open: false,
  });
  // const [isLoginModal, setIsLoginModal] = useState(false);
  const showMoreItems = () => {
    setVisible((prevValue) => prevValue + 4);
  };
  const { loginDataSuccess } = useSelector((state) => state.LoginData);
  const isLoggedIn = loginDataSuccess?.access_token;

  const isPropertyCategory =
    isbusiness?.businessCategory?.property_enable == 1 || false;

  const fetchBusinessDetail = async (id) => {
    setBusinessLoading(true)
    try {
      let body;
      if (id) {
        const user_uuid = localStorage.getItem("user_uuid");
        body = { business_id: id, user_uuid };
      }
      const response = await dispatch(getBusinessDetail(body));

      if (response?.type === "GET_BUSINESS_DETAILS_SUCCESS") {
        setBusiness(response?.payload);
        setBusinessHours(response?.payload?.businessHours[0]);
      }
    } catch (error) {
      // console.log(error)
    } finally {
      setBusinessLoading(false)
    }
  };

  const fetchBusinessOtherDetails = useCallback(async (id) => {
    setBusinessLoading(true)
    try {
      const isPropertyEnabled =
        isbusiness?.businessCategory?.property_enable == 1 || false;

      const res = await dispatch(getBusinessEvent(id));

      if (res?.type === "GET_BUSINESS_EVENT_SUCCESS") {
        setEvent(res.payload);
      }

      getAnnouncements(id).then((res) => {
        // // console.log(res);
        if (res.status === 200) {
          setAnnouncements(res.data?.announcements || []);
        }
      });
      getSales(id).then((res) => {
        // // console.log(res);
        if (res.status === 200) {
          setSales(res.data?.sales || []);
        }
      });
      getOffer(id).then((res) => {
        if (res.status === 200) {
          setOffers(res?.data?.offers);
        }
      });
      if (isPropertyEnabled) {
        getPropertyList(id).then((res) => {
          if (res.status === 200) {
            setProperty(res?.data?.result);
          }
        });
      }
    } catch (error) {
      // console.log(error)
    } finally {
      setBusinessLoading(false)
    }
  }, [isbusiness]);

  useEffect(() => {
    fetchBusinessDetail(id);
  }, [id]);

  useEffect(() => {
    if (id && isbusiness.id) {
      fetchBusinessOtherDetails(id)
    }
  }, [isbusiness, id])

  const handleFavoriteClick = async () => {
    if (!isLoggedIn) {
      navigate("/signin");
      return;
    }
    setLoading(true);
    try {
      const response = await dispatch(
        isbusiness.isFavourite
          ? removeFavorite({ business_id: isbusiness.id })
          : addFavorite({ business_id: isbusiness.id })
      );

      if (response?.payload?.status === 409) {
        toast.info(
          isbusiness.isFavourite
            ? "Business is already removed from favorites"
            : "Business is already added to favorites"
        );
        return;
      }

      if (
        response.type === "ADD_FAVORITE_SUCCESS" ||
        response.type === "REMOVE_FAVORITE_SUCCESS"
        // (response.type === "ADD_FAVORITE_ERROR" &&
        //   response.payload?.status === 409)
      ) {
        const user_uuid = localStorage.getItem("user_uuid");
        const updatedResponse = await dispatch(
          getBusinessDetail({ business_id: isbusiness.id, user_uuid })
        );
        if (updatedResponse?.type === "GET_BUSINESS_DETAILS_SUCCESS") {
          setBusiness(updatedResponse?.payload);
          toast.success(
            isbusiness.isFavourite
              ? "Business removed from favorites successfully"
              : "Business added to favorites successfully"
          );
        }
      }
    } catch (error) {
      console.error("Error handling favorite:", error);
    } finally {
      setLoading(false);
    }
  };

  const setIsLoginModal = () => {
    navigate('/signin')
  }

  const handleClick = (sale) => {
    if (isLoggedIn) {
      setSelectedSale(sale);
      setIsOpenSaleModal(true);
    } else {
      setIsLoginModal(true);
    }
  };

  const handleClose = () => {
    setIsOpenSaleModal(false);
  };

  return (
    <>
      {/* <LoginPopup
        isLoginModal={isLoginModal}
        setIsLoginModal={setIsLoginModal}
      /> */}
      <SalesPopup
        handleClose={handleClose}
        isOpenSaleModal={isOpenSaleModal}
        selectedSale={selectedSale}
      />
      <section className="vd-content pb-5">
        <div className="container">
          <div className="row businessDetails-alignItem">
            <div
              className="businessDetails-backBtn"
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            >
              <img src="/images/bi_arrow-right.svg" />
              Back
            </div>
            <div
              className="businessview"
              style={{
                display: "flex",
                // alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="col-md-7">
                <div className="vd-content-text">
                  <div className="businessDetails-heading-section">
                    <h3 className="businessDetails-title">
                      {isbusiness?.business_name}
                    </h3>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          color: "#fcfcfc",
                          fontSize: "14px",
                          fontWeight: 300,
                          textAlign: "initial",
                          marginBottom: "8px",
                        }}
                      >
                        {isbusiness?.tag_line}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        {isbusiness?.reviewAverage ? (
                          <div className="businessDetails-reviewStar">
                            {isbusiness?.reviewAverage != undefined &&
                              Array.from(
                                Array(parseInt(isbusiness?.reviewAverage)),
                                (e, i) => {
                                  return (
                                    <li key={i} className="reviewStar">
                                      <i
                                        className="fa-solid fa-star"
                                        style={{ fontSize: "15px" }}
                                      />
                                    </li>
                                  );
                                }
                              )}
                            {Array.from(
                              {
                                length:
                                  5 - parseInt(isbusiness?.reviewAverage || 0),
                              },
                              (e, j) => {
                                return (
                                  <li key={j + 5} style={{ listStyle: "none" }}>
                                    <i
                                      style={{
                                        marginRight: "4px",
                                        fontSize: "15px",
                                        listStyle: "none",
                                        color: '#3ca059'
                                      }}
                                      className="fa-regular fa-star"
                                    />
                                  </li>
                                );
                              }
                            )}
                            {isbusiness?.reviewCount && (
                              <span
                                style={{
                                  color: "#3ca059",
                                  fontWeight: "400",
                                  fontSize: "15px",
                                }}
                              >
                                ({isbusiness?.reviewCount} Reviews)
                              </span>
                            )}
                          </div>
                        ) : null}
                        {isbusiness?.active_buyer > 0 && (
                          <div
                            style={{
                              color: "#fff",
                              fontSize: 15,
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 3,
                            }}
                          >
                            <img
                              src="../images/activeBuyers.svg"
                              width={20}
                              height={20}
                              // className='suffixes3'
                              alt=""
                            />
                            {isbusiness?.active_buyer || 0} Active Buyers
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ display: "inline-block" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        {/* <div className="businessDetails-isFavourite">
                          <img src="/images/bxs_share.svg" width={24} />
                        </div> */}

                        <div>
                          {isbusiness.isFavourite === true ? (
                            <button
                              className="businessDetails-isFavourite"
                              onClick={handleFavoriteClick}
                              style={{
                                cursor: "pointer",
                                padding: "0",
                                background: "transparent",
                                border: "none",
                              }}
                              disabled={loading}
                            >
                              <i
                                className="fas fa-heart w-100"
                                style={{
                                  // color: "#3CA059",
                                  color: "#F03E3E",
                                  fontSize: "24px",
                                  margin: "0",
                                }}
                              />
                            </button>
                          ) : (
                            <button
                              className="businessDetails-isFavourite"
                              onClick={handleFavoriteClick}
                              style={{
                                cursor: "pointer",
                                padding: "0",
                                background: "transparent",
                                border: "none",
                              }}
                              disabled={loading}
                            >
                              <i
                                className="far fa-heart w-100"
                                style={{
                                  color: "#3CA059",
                                  fontSize: "24px",
                                  margin: "0",
                                }}
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <Slider isbusiness={isbusiness}
                    loading={businessLoading}
                  />
                  <p className="businessDetails-description">
                    {isbusiness?.description}
                  </p>
                  <div className="grab-container">
                    {/* <div className="grab-boxes">
                    <div className="row">
                      <div className="col-md-6 grab-box1">
                        <div className="grab-box-img">
                          <img
                            src="images/offercard34.png"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                      <div className="col-md-6 grab-box1">
                        <div className="grab-box-img">
                          <img
                            src="images/offercard34.png"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="vd-content-details">
                  <div className="contact-info" style={{ padding: "12px" }}>
                    <h4 style={{ borderBottom: "1px solid #282828" }}>
                      Contact Information
                    </h4>
                    <ul className="address-info">
                      {isbusiness?.phone && (
                        <li style={{ marginLeft: 0 }}>
                          <img src="../images/call-calling.svg" />{" "}
                          <a
                            href={`tel:${isbusiness?.country_code}${isbusiness?.phone}`}
                          >
                            {formatPhone(
                              `${isbusiness?.country_code}${isbusiness?.phone}`
                            )}
                          </a>
                        </li>
                      )}
                      {isbusiness?.business_email && (
                        <div
                          style={{
                            marginBottom: "12px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <i
                            className="fa-solid fa-envelope"
                            style={{
                              fontSize: "20px",
                              color: "#2d8646",
                            }}
                          />
                          <a
                            href={`mailto:${isbusiness?.business_email}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "#fff",
                              fontSize: "15px",
                              fontWeight: "200",
                              marginLeft: "10px",
                            }}
                          >
                            {isbusiness?.business_email}
                          </a>
                        </div>
                      )}
                      {isbusiness?.website && (
                        <li style={{ marginLeft: 0 }}>
                          <img src="../images/global.svg" />{" "}
                          <a
                            href={formatHttpsLink(isbusiness.website)}
                            target="_blank"
                          >
                            {isbusiness?.website}
                          </a>
                        </li>
                      )}
                      {isbusiness?.alternative_website && (
                        <li style={{ marginLeft: 0 }}>
                          <img src="../images/global.svg" />{" "}
                          <a
                            href={formatHttpsLink(
                              isbusiness.alternative_website
                            )}
                            target="_blank"
                          >
                            {isbusiness?.alternative_website}
                          </a>
                        </li>
                      )}
                      {isbusiness?.is_address_hide != 2 && (
                        <li
                          className="add-green"
                          style={{
                            marginLeft: 0,
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 5,
                          }}
                        >
                          <img src="../images/map.svg" />{" "}
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${isbusiness?.lat},${isbusiness?.lng}`}
                            target="_blank"
                          >
                            {isbusiness?.address1}
                            {isbusiness.city ? `, ${isbusiness.city}` : ''}{isbusiness.state ? `, ${isbusiness.state}` : ''}{isbusiness.country ? `, ${isbusiness.country}` : ''}{isbusiness.zipcode ? `, ${isbusiness.zipcode}` : ''}
                          </a>
                        </li>
                      )}
                      {/* {isbusiness?.users?.email_id && (
                        <div style={{ marginBottom: "12px" }}>
                          <i
                            className="fa-solid fa-envelope"
                            style={{
                              fontSize: "16px",
                              color: "#2d8646",
                            }}
                          />
                          <a
                            href={`mailto:${isbusiness?.users?.email_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "none",
                              color: "#fff",
                              fontSize: "15px",
                              fontWeight: "200",
                              marginLeft: "14px",
                            }}
                          >
                            {isbusiness?.users?.email_id}
                          </a>
                        </div>
                      )} */}
                    </ul>
                    <ul className="vd-socials">
                      {isbusiness?.facebook && (
                        <li>
                          <a
                            href={`${formatHttpsLink(isbusiness?.facebook)}`}
                            target="_blank"
                          >
                            <img src="../images/fb-icon.svg" />
                          </a>
                        </li>
                      )}
                      {isbusiness?.twitter && (
                        <li>
                          <a
                            href={`${formatHttpsLink(isbusiness?.twitter)}`}
                            target="_blank"
                          >
                            <img src="../images/x-icon.svg" />
                          </a>
                        </li>
                      )}
                      {isbusiness?.instagram && (
                        <li>
                          <a
                            href={`${formatHttpsLink(isbusiness?.instagram)}`}
                            target="_blank"
                          >
                            <img src="../images/insta-icon.svg" />
                          </a>
                        </li>
                      )}

                      {isbusiness?.youtube && (
                        <li>
                          <a
                            href={`${formatHttpsLink(isbusiness?.youtube)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="../images/yt-icon.svg"
                              style={{
                                background: "#49ab59",
                                borderRadius: "50%",
                              }}
                            />
                          </a>
                        </li>
                      )}
                      {isbusiness?.linkedIn && (
                        <li>
                          <a
                            href={`${formatHttpsLink(isbusiness?.linkedIn)}`}
                            target="_blank"
                          >
                            <img
                              src="../images/lind-icon.svg"
                              style={{ width: "30px" }}
                            />
                          </a>
                        </li>
                      )}
                      {isbusiness?.tiktok && (
                        <li>
                          <a
                            href={`${formatHttpsLink(isbusiness?.tiktok)}`}
                            target="_blank"
                          >
                            {/* <img src="../images/ticktock.svg" /> */}
                            <AiFillTikTok color="white" fontSize={"32px"} />
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      gap: "12px",
                    }}
                  >
                    <button
                      className="business-messageBtn"
                      style={{ position: "relative" }}
                      onClick={() => {
                        if (!isLoggedIn) {
                          setIsLoginModal(true);
                        }
                        else{
                          navigate("/chat", { 
                            state: { 
                             businessDetail: isbusiness,
                            } 
                          });
                        }
                      }}
                    >
                      {!isLoggedIn && ( <i
                        className="fas fa-lock"
                        style={{
                          color: "#349b52",
                          fontSize: "15px",
                          position: "absolute",
                          right: 5,
                          top: 4,
                        }}
                      />)}
                     
                      <img src="/images/msg.svg" width={20} />
                      Message
                    </button>
                    <button
                      className="business-telBtn"
                      onClick={() => {
                        window.open(
                          `tel:${isbusiness.country_code}${isbusiness.phone}`,
                          "_self"
                        );
                      }}
                    >
                      <img src="/images/phone-icon.svg" width={20} />
                      Call Now
                    </button>
                  </div> */}
                </div>
                {isBusinessHours?.day_hours && (
                  <div className="barber-accordion" style={{ width: "100%" }}>
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOpenHours"
                            aria-expanded="true"
                            aria-controls="collapseOpenHours"
                            style={{ fontSize: "18px", fontWeight: "600" }}
                          >
                            Opening Hours
                          </button>
                        </h2>

                        <div
                          id="collapseOpenHours"
                          className="accordion-collapse collapse "
                          aria-labelledby="headingOpenHours"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            {!isEmpty(isBusinessHours) &&
                              isArray(
                                JSON.parse(isBusinessHours?.day_hours)
                              ) && (
                                <div className="accordion-content-wrap">
                                  <BusinessOpenHours
                                    isBusinessHours={isBusinessHours}
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="barber-accordion">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Reviews
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className={`accordion-collapse collapse ${isbusiness?.userReview?.length > 0 ? "show" : ""
                      }`}
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Reviews isbusiness={isbusiness} visible={visible} showMoreItems={showMoreItems} isLoggedIn={isLoggedIn} business_id={id} handleRefresh={fetchBusinessDetail} />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Events
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className={`accordion-collapse collapse ${event?.events?.length > 0 ? "show" : ""
                      }`}
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div
                        className={
                          !isEmpty(event.events) && "businessDetails-sales-card"
                        }
                      >
                        <Events
                          event={event}
                          setIsLoginModal={setIsLoginModal}
                          isLoggedIn={isLoggedIn}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {isPropertyCategory && (
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Properties
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className={`accordion-collapse collapse ${propertyList?.length > 0 ? "show" : ""
                        }`}
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div
                          className={
                            !isEmpty(propertyList) &&
                            "businessDetails-sales-card"
                          }
                        >
                          <Property
                            propertyList={propertyList}
                            setIsLoginModal={setIsLoginModal}
                            isLoggedIn={isLoggedIn}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Announcements
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className={`accordion-collapse collapse ${announcements?.length > 0 ? "show" : ""
                      }`}
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div
                        className={
                          announcements?.length > 0 &&
                          "businessDetails-sales-card"
                        }
                      >
                        <Announcements announcements={announcements} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Sales
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className={`accordion-collapse collapse ${sales?.length > 0 ? "show" : ""
                      }`}
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div
                        className={
                          sales?.length > 0 && "businessDetails-sales-card"
                        }
                      >
                        <Sales sales={sales} handleClick={handleClick} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Offers
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className={`accordion-collapse collapse ${offers?.length > 0 ? "show" : ""
                      }`}
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div
                        className={
                          offers?.length > 0 && "businessDetails-sales-card"
                        }
                      >
                        <Offers offers={offers} isLoggedIn={isLoggedIn} setIsLoginModal={setIsLoginModal} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessDetails;
